let $tingle = require("tingle.js");
export default async function createSnippet() {
  tree = $.ui.fancytree.getTree("#tree-pane-component");
  const modal = new $tingle.modal({
    closeMethods: [],
    footer: true,
    stickyFooter: true
  });

  modal.open();
  modal.setContent("<p>Loading...</p>");

  modal.addFooterBtn("Create", "tingle-btn tingle-btn--primary tingle-btn--pull-right", function() {
    const form = document.getElementById("tephra_snippet_theme_form");
    const nameInputs = [$("#tephra_snippet_reference"), $("#tephra_snippet_family_other")];

    sanitizeInputs(nameInputs);
    // clear the "others" input if it's not visible to the user
    !$("#tephra_snippet_family_other").is(":visible") && $("#tephra_snippet_family_other").val("");

    const isValidName = isValidFileNames(nameInputs);

    if (!isValidName) {
      alert("file name/family is not valid!");
      return false;
    }

    const prebuiltValue = document.getElementById('tephra_snippet_prebuilt').checked ? 1 : 0;
    const formData = new FormData(form);
    CodeEditor.TephraManager.createTephraSnippet(
      formData.get("tephra_snippet[family]"),
      formData.get("tephra_snippet[family_other]"),
      formData.get("tephra_snippet[reference]"),
      prebuiltValue
    ).then(() => {
      modal.destroy();
    });
  });

  modal.addFooterBtn("Cancel", "tingle-btn tingle-btn--default tingle-btn--pull-right", function() {
    modal.destroy();
  });

  const data = await CodeEditor.TephraManager.getTephraSnippetNewForm();
  try {
    $(".tingle-modal-box__content").html(data);
    $("#tephra_snippet_asset_ids").select2();
  } catch (e) {
    alert(e);
  }
}

/**
 * Sanitizes strings inside of input fields.
 * This function mutates the dom directly and doesn't return anything
 * @function sanitizeInputs
 * @param  {Array} inputs An Array of JQuery inputs
 */
function sanitizeInputs(inputs) {
  inputs.forEach(input => {
    const value = $(input).val();
    $(input).val(value.replace(/\s/g, "_"));
  });
}

/**
 * @function isValidFileNames
 * @param  {Array} inputs An Array of JQuery inputs
 * @return {Boolean} A boolean returning `true` if valid `false` if otherwise
 */
function isValidFileNames(inputs) {
  const validFilename = require("../utils").validFilename;
  return inputs.some(name => {
    const hasValue = $(name).val().length > 0;
    if (hasValue) return validFilename($(name).val());
    return false;
  });
}
